import React from 'react';
import Select from "../../presentational/Select";
import { useConfiguration } from './Configuration';

import useAuthenticationStore from './Store';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { changeLanguage, state, locales } = useAuthenticationStore();
  const { configuration } = useConfiguration();
  const { currentLanguage } = state;

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value;
    changeLanguage(newLanguage);
  };

  if (locales().length <= 1) {
    return null;
  }

  return (
    <div className='language-switcher'>
      <Select
        value={currentLanguage}
        id="page-language"
        onChange={handleChange}
        size='small'
      >
        {locales().map(({ Code, Language, LocalizedName }) => (
          <option key={Code} value={Code}>
            {LocalizedName}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default LanguageSwitcher;